import React from 'react';
import './Modal.css';

const Modal = ({ isOpen, onClose, onSubmit, remarks, setRemarks, name }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <h3>Enter Remarks for {name}</h3>
        <textarea
          rows="4"
          placeholder="Write your remarks..."
          value={remarks}
          onChange={(e) => setRemarks(e.target.value)}
        />
        <div className="modal-buttons">
          <button onClick={onSubmit}>Submit</button>
          <button className="cancel" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
